import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    variantId: Number,
    candleId: Number,
    favorite: Boolean
  }

  connect() {
  }

  toggle(event) {
    event.preventDefault()

    const url = `/crafting/perfumed_candles/${this.candleIdValue}/variants/${this.variantIdValue}/toggle_favorite`

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Update the favorite value
      this.favoriteValue = data.favorite

      // Update the button appearance
      const button = this.element
      const icon = button.querySelector('i')

      if (data.favorite) {
        // Favorite state
        button.classList.remove('btn-outline-warning')
        button.classList.add('btn-warning')
        icon.classList.remove('fa-regular')
        icon.classList.add('fa-solid')
        button.title = 'Remove from favorites'
      } else {
        // Not favorite state
        button.classList.remove('btn-warning')
        button.classList.add('btn-outline-warning')
        icon.classList.remove('fa-solid')
        icon.classList.add('fa-regular')
        button.title = 'Mark as favorite'
      }
    })
    .catch(error => {
      console.error('Error toggling favorite:', error)
    })
  }
}

